import React from "react";
import "./index.css";

/**
 * Marks a page region as a Charge Journey chapter (slide).
 */
const ChapterSlide = ({ id, active, children, className = "", style, as: Tag = "div" }) => {
  return (
    <Tag
      data-flash-chapter={id}
      className={`flash-chapter${active ? " is-active" : ""}${className ? ` ${className}` : ""}`}
      style={style}
    >
      <span className="flash-chapter__energy" aria-hidden="true" />
      <span className="flash-chapter__curtain" aria-hidden="true" />
      <div className="flash-chapter__inner">{children}</div>
    </Tag>
  );
};

export default ChapterSlide;
